app.controller('popupAuthorizedPersonController', ['$scope', '$state', '$mdDialog', 'objectHelper', 'baseModel', 'applicationModel', 'dictionaryModel', 'authorizedPersonData',
    function ($scope, $state, $mdDialog, objectHelper, baseModel, applicationModel, dictionaryModel, authorizedPersonData) {

        function setData() {
            if(authorizedPersonData) {
                $scope.authorizedPerson = authorizedPersonData;
            } else {
                $scope.authorizedPerson = new AuthorizedPersonVO();
                $scope.authorizedPerson.address = new AddressVO();
            }

            $scope.citizenshipList = [];
            $scope.stateList = [];
            $scope.numbersOnlyRegExp = '^\\d+$';

            $scope.forms = {
                authorizedPerson: null
            }
        }

        function setPermissions() {
        }

        function setListeners() {

            $scope.$on(Event.DICTIONARY.GET_DICTIONARY_ELEMENT_DATA_PAGE.SUCCESS, function (event, dataPage, code) {
                if(code === Constant.DICTIONARY_CODE.CITIZENSHIP) {
                    $scope.citizenshipList = dataPage.data;
                }
                if(code === Constant.DICTIONARY_CODE.STATE) {
                    $scope.stateList = dataPage.data;
                }
            });


        }

        function setActions() {
            $scope.save = function() {
                $scope.forms.authorizedPerson.$setSubmitted();
                if($scope.forms.authorizedPerson.$valid) {
                    $mdDialog.hide($scope.authorizedPerson);
                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };
        }

        function configureInterface() {

        }

        function initialize() {
            var criteria = {};
            dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.CITIZENSHIP, criteria);
            dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.STATE, criteria);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);